import { createSelector } from '@reduxjs/toolkit'
import { isCompanyLegal, isSoleLegal } from 'modules/customer/helpers'
import { TypeRootState } from 'store/store'

import { CustomerAddLocationKeys } from './constants'

const customerInnForSelect = (state: TypeRootState, key: CustomerAddLocationKeys) =>
  state.customerAddReducer[key].customerInfo?.inn || state.customerAddReducer[key].selectedOptions?.inn
const isDadataAddressDisableForSelect = (state: TypeRootState, key: CustomerAddLocationKeys) =>
  state.customerAddReducer[key].isDadataAddressDisable
const isDadataCustomerDisableForSelect = (state: TypeRootState, key: CustomerAddLocationKeys) =>
  state.customerAddReducer[key].isDadataCustomerDisable

export const isIpSelector = createSelector([customerInnForSelect], isSoleLegal)
export const isLegalSelector = createSelector([customerInnForSelect], isCompanyLegal)

export const isActiveManualEntryAddressSelector = createSelector(
  [customerInnForSelect, isDadataAddressDisableForSelect, isDadataCustomerDisableForSelect],
  (customerInn, isDadataAddressDisable, isDadataCustomerDisable) =>
    (isSoleLegal(customerInn) && isDadataAddressDisable) || isDadataCustomerDisable
)
